// Overlay de controles do canvas: [-] [zoom%] [+] [fit] [tools].

export function Toolbar({
  zoomPct,
  collapsed,
  onZoomIn,
  onZoomOut,
  onFit,
  onToggleTools,
}: {
  zoomPct: number;
  collapsed: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: () => void;
  onToggleTools: () => void;
}) {
  const btn =
    'inline-flex items-center justify-center size-8 rounded-md bg-card border border-border hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50';
  return (
    <div class="absolute top-3 left-3 z-30 flex items-center gap-1.5">
      <div class="flex items-center gap-1 bg-card border border-border rounded-md p-1">
        <button type="button" class={btn} title="Diminuir zoom" onClick={onZoomOut}>
          <i class="ph ph-minus text-base" />
        </button>
        <span class="px-1.5 text-xs font-mono tabular-nums text-muted-foreground min-w-12 text-center">
          {zoomPct}%
        </span>
        <button type="button" class={btn} title="Aumentar zoom" onClick={onZoomIn}>
          <i class="ph ph-plus text-base" />
        </button>
      </div>
      <button type="button" class={btn} title="Enquadrar tudo" onClick={onFit}>
        <i class="ph ph-arrows-out text-base" />
      </button>
      <button
        type="button"
        class={`${btn} ${collapsed ? '' : 'bg-accent text-accent-foreground'}`}
        title={collapsed ? 'Mostrar tools' : 'Ocultar tools'}
        onClick={onToggleTools}
      >
        <i class={`${collapsed ? 'ph' : 'ph-bold'} ph-tree-view text-base`} />
      </button>
    </div>
  );
}
